import { SettingsModule } from '@app/services/settings/utils/settings-module';
import { SettingsSubModule } from '@app/services/settings/utils/settings-sub-module';
import { SettingValue } from '@app/services/settings/utils/setting-value';

export namespace OrganizationsFields {
  export enum ModuleField {
    FolderNamePattern = 'Organizations.FolderNamePattern',
    EnableAutogeneratedFolders = 'Organizations.EnableAutogeneratedFolders',
    RootFolderName = 'Organizations.RootFolderName',
    SortOrder = 'Organizations.SortOrder',
    DontGenerateFoldersIfServiceCovers = 'DontGenerateFoldersIfServiceCovers',
  }
}

class ModuleConfig extends SettingsSubModule {
  @SettingsSubModule.value(OrganizationsFields.ModuleField.FolderNamePattern, '')
  folderNamePattern: SettingValue<string>;
  @SettingsSubModule.value(OrganizationsFields.ModuleField.EnableAutogeneratedFolders, false)
  enableAutogeneratedFolders: SettingValue<boolean>;
  @SettingsSubModule.value(OrganizationsFields.ModuleField.RootFolderName, '')
  rootFolderName: SettingValue<string>;
  @SettingsSubModule.value(OrganizationsFields.ModuleField.SortOrder, 0)
  sortOrder: SettingValue<number>;
  @SettingsSubModule.value(OrganizationsFields.ModuleField.DontGenerateFoldersIfServiceCovers, false)
  dontGenerateFoldersIfServiceCovers: SettingValue<boolean>;
}

export class OrganizationsModule extends SettingsModule {
  @SettingsModule.value(ModuleConfig) module: ModuleConfig;
}
